/**
 * 登录拦截：后端对评论、点赞等写操作返回 H5_LOGIN_REQUIRED 时，
 * 弹出登录框，登录成功后自动重放刚才那次请求——业务代码无需改动。
 *
 * 同一时刻只弹一个框；多个请求同时被拦截时共用同一次登录，登录完一起重试。
 */
let opener = null
let pending = null

// 由挂载登录框的组件注册；未注册时拦截器直接放行错误
export const registerLoginOpener = (fn) => {
  opener = fn
}

export const requestLogin = () => {
  if (!opener) return Promise.reject(new Error('NO_LOGIN_UI'))
  if (pending) return pending
  pending = new Promise((resolve, reject) => {
    opener({
      onSuccess: (result) => {
        pending = null
        resolve(result)
      },
      onCancel: () => {
        pending = null
        reject(new Error('LOGIN_CANCELLED'))
      },
    })
  })
  return pending
}

export const __reset = () => {
  opener = null
  pending = null
}

/**
 * 互动前确认已登录：已登录直接放行，未登录先弹框。
 *
 * 供组件在「本地乐观更新之前」调用——否则会出现先 +1、请求被拒后再回退、
 * 然后才弹登录框的观感。
 */
export const ensureLoggedIn = () => {
  const { getVerifiedToken } = require('./h5Session')
  if (getVerifiedToken()) return Promise.resolve(true)
  return requestLogin().then(() => true)
}



// WEBPACK FOOTER //
// ./src/common/loginGate.js